import React, { useEffect } from "react";
import { useHistory, generatePath } from "react-router-dom";
import { observer } from "mobx-react";

import {
  SnackbarContextProps,
  withGlobalSnackbar,
} from "services/snackbar/snackbarContext";
import Container from "components/Layout/Container";
import Controls from "./Controls";
import FilteringControl from "components/FilteringControl";
import Header from "components/Layout/Header";
import List from "./List";
import Page from "components/Layout/Page";
import PublishButton from "components/PublishButton";
import SortingControl from "components/SortingControl";
import TriviaStore from "../TriviaStore";
import {
  FilterContainer,
  Search,
  FiltersWrapper,
  OverflowLoader,
} from "./styles";
import { TableSortType } from "stores/templates/TableStore";
import ROUTES from "navigation/routes";
import { SNACKBAR_TYPES } from "components/Snackbar/Snackbar";
const MINIMUM_SEARCH_VALUE_LENGTH = 3;

const ContentTrivia = ({ setMessage }: SnackbarContextProps) => {
  const history = useHistory();

  const onAddClick = () => {
    history.push({
      pathname: generatePath(ROUTES.CONTENT_TRIVIA_DETAIL),
      state: { editMode: true },
    });
  };

  const onFilterApply = (
    filterValues: { column: string; value: (string | number)[] }[],
  ) => {
    filterValues.map(filterValue =>
      TriviaStore.applyFilter({
        column: filterValue.column,
        value: filterValue.value,
      }),
    );
    TriviaStore.fetch();
  };

  const onFilterClear = () => {
    TriviaStore.clearFilters();
    TriviaStore.fetch();
  };

  const onSearchApply = (value: string) => {
    if (value.length === 0) {
      onSearchClear();
      return;
    }

    TriviaStore.applySearch(value);
    value.length >= MINIMUM_SEARCH_VALUE_LENGTH && TriviaStore.fetch();
  };

  const onSortApply = (value: TableSortType) => {
    TriviaStore.applyOrder(value);
    TriviaStore.resetPage();
    TriviaStore.fetch();
  };

  const onSearchClear = () => {
    TriviaStore.clearSearch();
    TriviaStore.fetch();
  };

  const onPublishClick = (trivia: any) => {
    const { id, publishStatus } = trivia;

    try {
      TriviaStore.changeTriviaStatus(id, publishStatus);
    } catch (error) {
      setMessage(error?.message, SNACKBAR_TYPES.ERROR);
    }
  };

  useEffect(() => {
    TriviaStore.fetch();
  }, []);

  return (
    <Container header={<Header controls={<PublishButton />} />}>
      <Page
        title="Trivia"
        controls={<Controls onAddClick={onAddClick} />}
        isLoading={TriviaStore.isLoading}
      >
        <FilterContainer>
          <Search
            initValue={TriviaStore.search}
            onApply={onSearchApply}
            onClear={onSearchClear}
          />
          <FiltersWrapper>
            <SortingControl
              initValue={TriviaStore.orderContext.appliedOrderInfo}
              onApply={onSortApply}
            />
            <FilteringControl
              initValue={TriviaStore.filters}
              onApply={onFilterApply}
              onClear={onFilterClear}
              statusFiltering
            />
          </FiltersWrapper>
        </FilterContainer>

        {TriviaStore.isPublishing && <OverflowLoader />}

        <List
          items={TriviaStore.items}
          isEmpty={TriviaStore.items.length === 0}
          text={
            TriviaStore.search
              ? "No matches found. Please try another search."
              : "No trivias added yet."
          }
          onPublish={onPublishClick}
        />
      </Page>
    </Container>
  );
};

export default withGlobalSnackbar(observer(ContentTrivia));
